import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationTriangle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_18783_13148)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M30 37.5C31.5586 37.5 32.8125 36.2461 32.8125 34.6875V19.6875C32.8125 18.1348 31.5527 16.875 30.1055 16.875C28.6582 16.875 27.1875 18.1406 27.1875 19.6875V34.6875C27.1875 36.2461 28.4531 37.5 30 37.5ZM30 41.3789C27.9656 41.3789 26.3156 43.0289 26.3156 45.0633C26.3203 47.0977 27.9609 48.75 30 48.75C32.0391 48.75 33.6844 47.1 33.6844 45.0656C33.6797 43.0312 32.0391 41.3789 30 41.3789Z",
			fill: "#697177"
		}), /* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M59.332 48.8672L34.3359 6.21094C32.4223 2.92969 27.593 2.92969 25.6664 6.21094L0.68203 48.8672C-1.24102 52.1367 1.15418 56.25 5.00859 56.25H55.0008C58.8398 56.25 61.2422 52.1484 59.332 48.8672ZM27.1875 19.6875C27.1875 18.1348 28.4473 16.875 30 16.875C31.5527 16.875 32.8125 18.1406 32.8125 19.6875V34.6875C32.8125 36.2402 31.5527 37.5 30.1055 37.5C28.6582 37.5 27.1875 36.2461 27.1875 34.6875V19.6875ZM30 48.75C27.9656 48.75 26.3156 47.1 26.3156 45.0656C26.3156 43.0312 27.9644 41.3812 30 41.3812C32.0355 41.3812 33.6844 43.0312 33.6844 45.0656C33.6797 47.0977 32.0391 48.75 30 48.75Z",
			fill: "#697177"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_18783_13148",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 60,
			height: 60
		})
	}) })]
});
export default SvgExclamationTriangle;
